'use strict';

var defaults = require('./../defaults');
var utils = require('./../utils');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var isAbsoluteURL = require('./../helpers/isAbsoluteURL');
var combineURLs = require('./../helpers/combineURLs');
var pub = require('../../../../common/js/public');

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/*axiosGet接口地址过滤 */
Axios.prototype.FilterApi = function(url, config, method) {
  var _this = this;
  return new Promise(function(resolve, rejecte) {
    resolve(
      _this.request(
        utils.merge(config || {}, {
          method: method,
          url: url
        })
      )
    );
  });
};

/*axiosPost接口地址过滤 */
Axios.prototype.FilterApiPost = function(url, data, config, method) {
  var _this = this;
  return new Promise(function(resolve, rejecte) {
    resolve(
      _this.request(
        utils.merge(config || {}, {
          method: method,
          url: url,
          data: data
        })
      )
    );
  });
};

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  // var arr, reg = new RegExp("(^| )CentaNet_PassPort_USERTOKEN=([^;]*)(;|$)");
  // if (arr = document.cookie.match(reg)) {
  //     if (config.headers === undefined) config.headers = {};
  //         config.headers.CentaNet_PassPort_USERTOKEN = unescape(arr[2]);
  // }

  // if (config.url.indexOf("com/m/") > -1 || config.url.indexOf("/v4/") > -1) {
  //   if (config.method == "get") {
  //     if (config.params == undefined) config.params = {};
  //     config.params.platform = "wap";
  //   } else {
  //     if (!config.data) config.data = "platform=wap";
  //     else config.data = config.data + "&platform=wap";
  //   }
  // //   if (config.headers == undefined) config.headers = {};
  // //     config.headers.platform = "wap";
  // }
  // var configs=require('../../../../common/js/config');

  if (config.url.indexOf('centa-coin') == -1) {
    if (config.method == 'get') {
      if (config.params == undefined) config.params = {};
      config.params.cityen = configs.City;
      config.params.platform = 'wap';
    } else {
      if (config.url.indexOf('ocpc/uploaddata') == -1) {
        if (config.params == undefined) config.params = {};
        config.params.cityen = configs.City;
        config.params.platform = "wap";
        if (!config.headers) config.headers = {};
        config.headers.cityen = configs.City;
        config.headers.platform = 'wap';
      }
    }
  }
  // 工具类租售委托gz
  if (config.url.indexOf('CreateTrustInto') > -1) {
    delete config.headers.cityen;
    delete config.headers.platform;
    console.log('axios', 1);
  }
  //A+楼盘 栋座查询sz 
  if (config.url.indexOf('get_Prop_param_hint_new') > -1) {
    delete config.headers.cityen;
    delete config.headers.platform;
  }
  
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge(
      {
        url: arguments[0]
      },
      arguments[1]
    );
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(
    interceptor
  ) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(
    interceptor
  ) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(
  ['delete', 'get', 'head', 'options'],
  function forEachMethodNoData(method) {
    Axios.prototype[method] = function(url, config) {
      return this.FilterApi(url, config, method);
    };
  }
);

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.FilterApiPost(url, data, config, method);
  };
});

module.exports = Axios;



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/core/Axios.js
// module id = XmWM
// module chunks = 0